import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionEft } from "../../../api/transaction-type";
import {
  salesOrderBillEftPaymentInfoTable,
  salesOrderBatchTransactionInfoTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { getTransactioninvoiceAccounting } from "../../../api/invoice";

export default function QuoteAccounting({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];

  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token) {
      getTransactionAccountingData();
    }
  }, []);

  async function getTransactionAccountingData() {
    setLoading(true);
    try {
      const { data } = await getTransactioninvoiceAccounting(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      setLoading(false);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

 return (
    <>
      {loading ? (
        <>
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <Grid item xs={12}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress></CircularProgress>
                </div>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
      
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12} sm={12} md={12} className="m-b-10">
              <p className="titleHeading">ACCOUNT INFORMATION</p>
            </Grid>
            <Grid item xs={12} sm={12} className="m-b-10">
              <p className="tFormlabel">CURRENCY</p>
              <p className="tFormName">{rowData[0]?.currency}</p>
            </Grid>   
            <Grid item xs={12} sm={12} className="m-b-10">
              <p className="tFormlabel">EXCHANGE RATE</p>
              <p className="tFormName">{rowData[0]?.exchangerate}</p>
            </Grid>

          </Grid>
        </Box>
 )
}
</>)
}
